import { BasicPopup } from "./BasicPopup";
import { ActionType } from "../State/State";
import { useContext } from "react";
import { AppContext } from "../State/Context";
import { img } from "../utils/settings";
import { getWorldCoordsToCenterHex } from "../State/stateUtils";
import { RequestMethod } from "../api/api";
import { askAPI } from "../api/api";

// Separate type for notification
type Notification = {
  createdAt: string;
  isRead: boolean;
  message: string;
  coordinates?: {
    x: number;
    y: number;
  };
};

// Separate component for notification item
const NotificationItem = ({
  notification,
  onHexClick,
}: {
  notification: Notification;
  onHexClick: (x: number, y: number) => void;
}) => (
  <div
    className={`flex mb-4 items-center cursor-pointer relative ${
      notification.isRead ? "" : "px-8 py-2"
    }`}
    onClick={() =>
      onHexClick(notification.coordinates!.x, notification.coordinates!.y)
    }
  >
    {!notification.isRead && (
      <div className="absolute top-16 left-1 text-xl">👁️‍🗨️</div>
    )}
    {notification.coordinates && (
      <img
        src={img(
          `x${notification.coordinates.x}y${notification.coordinates.y}.png`
        )}
        alt="hexagen"
        width={notification.isRead ? 80 : 140}
        height={notification.isRead ? 80 : 140}
        className="mr-4"
      />
    )}
    <div className="mr-4 whitespace-pre-line text-[13px]">
      {notification.message}
    </div>
  </div>
);

export const NotificationsPopup = () => {
  const { state, dispatch } = useContext(AppContext);
  const notifications = state.notifications;

  const closePopup = async () => {
    dispatch({ type: ActionType.TOGGLE_NOTIFICATIONS_POPUP });
    await askAPI("/api/notifications/mark-all-as-read", RequestMethod.POST);
    dispatch({
      type: ActionType.UPDATE_NOTIFICATIONS,
      notifications: notifications.map((notification) => ({
        ...notification,
        isRead: true,
      })),
    });
  };

  const handleHexClick = (x: number, y: number) => {
    dispatch({ type: ActionType.SELECT_HEX, x, y });
    dispatch({ type: ActionType.OPEN_HEX_INFO_POPUP });
    dispatch({ type: ActionType.TOGGLE_NOTIFICATIONS_POPUP });
    const coords = getWorldCoordsToCenterHex(x, y, state.worldScale);
    dispatch({ type: ActionType.CHANGE_WORLD_COORDINATES, x: coords.worldX, y: coords.worldY });
  };

  return (
    <BasicPopup onClose={closePopup}>
      <div>
        <div className="text-lg font-bold mb-4">Notifications</div>
        {notifications.length === 0 ? (
          <div>No notifications</div>
        ) : (
          notifications.map((notification, i) => (
            <NotificationItem
              key={i}
              notification={notification}
              onHexClick={handleHexClick}
            />
          ))
        )}
      </div>
    </BasicPopup>
  );
};
